import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";

const ContactUs = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };
    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(
                "service_ttnco5u",
                "template_rfpot2v",
                "#myForm",
                "FhLtO02IwcAuGDfR1"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");
                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };
    return (
        <>
            <div className="dz-bnr-inr dz-banner-dark overlay-secondary-middle dz-bnr-inr-md" style={{ background: "url(./assets/img/Hospital.jpg)" }}>
                <div className="container">
                    <div className="dz-bnr-inr-entry d-table-cell">
                        <h1 className="" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp', color: "white" }}>हमसे संपर्क करें</h1>
                        <nav aria-label="breadcrumb" className="breadcrumb-row wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                            <ul className="">
                                <li className="breadcrumb-item"><Link to="/">होम</Link></li>
                                <li className="breadcrumb-item">हमसे संपर्क करें</li>
                            </ul>
                        </nav>
                        <div className="dz-btn">
                            <a href="tel:+91 9165155945" className="btn btn-lg btn-icon btn-primary radius-xl btn-shadow mb-3 mb-sm-0">
                                <span className="left-icon">
                                    <i className="feather icon-phone-call" />
                                </span>
                                +91 9165155945
                            </a>
                        </div>
                    </div>
                </div>
                <span className="text-vertical">24/7 आपातकालीन सेवा</span>
                <ul className="dz-social">
                    <li>
                        <Link to="https://www.facebook.com/p/Omkar-Multispeciality-Hospital-61578676481836/" target="_blank">
                            <i className="fa-brands fa-facebook-f" />
                        </Link>
                    </li>
                    <li>
                        <a to="https://www.instagram.com" target="_blank">
                            <i className="fa-brands fa-instagram" />
                        </a>
                    </li>

                    <li>
                        <a to="https://twitter.com" target="_blank">
                            <i className="fa-brands fa-x-twitter" />
                        </a>
                    </li>
                    <li>
                        <a to="https://www.youtube.com" target="_blank">
                            <i className="fa-brands fa-youtube" />
                        </a>
                    </li>
                </ul>
            </div>

            <section className="content-inner">
                <div className="container">
                    <div className="row g-xl-4 align-items-center">
                        <div className="col-xl-7 pe-xl-4 m-b10">
                            <div className="section-head style-1 m-b30">
                                <h2 className="title wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.5s" style={{ visibility: 'visible', animationDuration: '0.5s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>अपनी हेल्थकेयर ज़रूरतों  <br /> के लिए हमसे जुड़ें</h2>
                            </div>
                            <div className="row">

                                <div className="col-md-5 m-b20 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.5s" style={{ visibility: 'visible', animationDuration: '0.5s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    <div className="icon-bx-wraper style-8 box-hover">
                                        <div className="icon-bx">
                                            <span className="icon-cell">
                                                <i className="feather icon-phone" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="dz-title">हमें कॉल करें</h4>
                                            <p><a href="tel:+91 9165155945" className="text-body">+91 9165155945</a></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-7 m-b20 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.5s" style={{ visibility: 'visible', animationDuration: '0.5s', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                                    <div className="icon-bx-wraper style-8 box-hover">
                                        <div className="icon-bx">
                                            <span className="icon-cell">
                                                <i className="feather icon-mail" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="dz-title">हमें ईमेल भेजें</h4>
                                            <p>

                                                <a href="mailto:omkarmultispecialityhospital1@gmail.com" className="text-body">omkarmultispecialityhospital1@gmail.com</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 m-b20 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.5s" style={{ visibility: 'visible', animationDuration: '0.5s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                                    <div className="icon-bx-wraper style-8 box-hover">
                                        <div className="icon-bx">
                                            <span className="icon-cell">
                                                <i className="feather icon-map-pin" />
                                            </span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="dz-title">पता</h4>
                                            <a href='https://share.google/1dX2BUSmYFvqcAmb9' style={{ color: "rgb(86 101 147)" }}>
                                                <p>Omkar Multispeciality Hospital, Near Andhiyarkhop Talab, National Highway No. NH53, Arang, Raipur (C.G.) 493441</p>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-5 m-b30 skrollable skrollable-between" data-bottom-top="transform: translateY(50px)" data-top-bottom="transform: translateY(-50px)" style={{ transform: 'translateY(19.7566px)' }}>
                            <div className="form-wrapper style-1">
                                <div className="form-body bg-primary background-blend-burn" style={{ backgroundImage: 'url(images/background/bg2.png)', backgroundSize: 'cover' }}>
                                    <div className="section-head style-1 m-b30">
                                        <h2 className="title text-white m-b0">संपर्क करें</h2>
                                        <p className="text-white m-b0 fw-medium">आप हमसे कभी भी संपर्क कर सकते हैं।</p>
                                    </div>
                                    <form className="dzForm" method="post" onSubmit={sendEmail} id="myForm">
                                        <input type="hidden" className="form-control" name="dzToDo" defaultValue="Contact" />
                                        <input type="hidden" className="form-control" name="reCaptchaEnable" defaultValue={0} />
                                        <div className="dzFormMsg" />
                                        <div className="row">
                                            <div className="col-sm-12 m-b30">
                                                <div className="form-floating floating-underline input-light">
                                                    <input type="text" className="form-control" id="inputFirstName" placeholder="First Name"
                                                        name="from_name"
                                                        onChange={(e) => nameChange(e)}
                                                        required
                                                        value={name}
                                                    />
                                                    <label htmlFor="inputFirstName">Full Name</label>
                                                </div>
                                            </div>

                                            <div className="col-sm-6 m-b30">
                                                <div className="form-floating floating-underline input-light">
                                                    <input type="email" className="form-control" placeholder="Your Email"
                                                        id="email"
                                                        name='email'
                                                        onChange={(e) => mailChange(e)}
                                                        value={mail}
                                                        required
                                                    />
                                                    <label htmlFor="inputYourEmail">Your Email</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 m-b30">
                                                <div className="form-floating floating-underline input-light">
                                                    <input type="text" className="form-control dz-number" placeholder="Phone Number"
                                                        id="phone"
                                                        name='phone'
                                                        onChange={(e) => numberChange(e)}
                                                        value={number}
                                                        required
                                                    />
                                                    <label htmlFor="inputPhoneNumber">Phone Number</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 m-b30">
                                                <div className="form-floating floating-underline input-light">
                                                    <textarea className="form-control" id="inputMessage" rows={6} placeholder="Select Service"
                                                        onChange={(e) => massagesChange(e)}
                                                        name='massage'
                                                        value={massages}
                                                        required
                                                    />
                                                    <label htmlFor="inputMessage">Message</label>
                                                </div>
                                            </div>
                                            <div className="col-sm-12">

                                                <button type="submit" name="submit" value="submit" className="btn btn-lg btn-icon btn-white hover-secondary btn-shadow">
                                                    Submit <span className="right-icon"><i className="feather icon-arrow-right" /></span>
                                                </button>

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div style={{ marginBottom: "" }} className="clearfix">
                <div className="map-wrapper style-2">

                    <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=900&hl=en&q=Omkar Multispeciality Hospital NH53, near Andhiyarkhop, Arang, Raipur, Chhattisgarh 493441&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google map embed html</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:900px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:900px;}.gmap_iframe {height:900px!important;}" }} /></div>
                </div>
            </div>


        </>
    )
}

export default ContactUs